import React from 'react';
import { Link, useParams } from 'react-router-dom';
import SEO from '../components/SEO';
import { getBlogPostBySlug } from '../data/blogPosts';

const BlogPost = () => {
  const { slug } = useParams();
  const post = getBlogPostBySlug(slug);

  if (!post) {
    return (
      <div className="calculator-page fade-in blog-page">
        <div className="info-box">
          <h4>Post not found</h4>
          <p>The blog article you are looking for does not exist.</p>
          <Link to="/blog" className="blog-read-link">Back to Blog</Link>
        </div>
      </div>
    );
  }

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    return date.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  };

  return (
    <div className="calculator-page fade-in blog-page">
      <SEO
        title={post.title}
        description={post.excerpt}
        keywords={post.keywords}
        canonicalPath={`/blog/${post.slug}`}
        article={{
          title: post.title,
          description: post.excerpt,
          datePublished: post.publishedAt,
        }}
      />

      <article className="blog-post">
        <Link to="/blog" className="blog-back-link">Back to Blog</Link>
        <div className="blog-card-meta">
          <span className="blog-card-category">{post.category}</span>
          <span>{formatDate(post.publishedAt)}</span>
          <span>{post.readMinutes} min read</span>
        </div>
        <h1>{post.title}</h1>
        <p className="blog-card-excerpt">{post.excerpt}</p>

        <div className="blog-post-content">
          {post.content.split('\n\n').map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </div>

        {post.relatedTool && (
          <div className="info-box" style={{ marginTop: '28px' }}>
            <h4>Try Related Tool</h4>
            <p>Open the matching calculator to apply this article with your own numbers.</p>
            <Link to={post.relatedTool} className="blog-read-link">Open Calculator</Link>
          </div>
        )}
      </article>
    </div>
  );
};

export default BlogPost;
